import React from 'react';
import MuiContainer from '@material-ui/core/Container/Container'
import config from '../../config/config';

interface IContainerProps {
  children: React.ReactFragment
}

const Container = ({children}: IContainerProps) => {
  return (
    <MuiContainer>
      {children}
    </MuiContainer>
  );
}

const ContainerWrapper = ({children}: IContainerProps) => {
  return config.fullPage ? <Container>{children}</Container> : <>{children}</>;
}

export default ContainerWrapper
